import * as yup from 'yup'

const LoginValidator = yup.object({
    email: yup.string().email().required("Email is required"),
    password: yup.string().required("Password is required"),
})

export { LoginValidator }